import React from 'react';
import { Card, CheckboxLabel, Form } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import './organizerProfile.scss';

const CheckBoxLabelContainer = ({ formOrganisation, onChange, organisationErrors }) => {
    const { t } = useTranslation();

    return (
        <CheckboxLabel
            className="wz-class"
            errors={!!organisationErrors?.['sworn']}
            label={t('ticket.organiser.sworn_statement.label')}
            name="checkboxA"
            onChange={(e, { checked }) => onChange('sworn', checked)}
            checked={formOrganisation.sworn}
            required
        />
    );
};
CheckBoxLabelContainer.propTypes = {
    formOrganisation: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired
};
export default function SwornStatement({ formOrganisation, onChange, organisationErrors = null }) {
    const { t } = useTranslation();

    return (
        <Card.FormStep className="organizer-formstep-form" title={t(`ticket.organiser.sworn_statement.title`)} rightComponent id="organiser-form-general_information">
            <>
                <CheckBoxLabelContainer onChange={onChange} formOrganisation={formOrganisation} organisationErrors={organisationErrors} />
                <Form.FieldErrors errors={organisationErrors?.['sworn'] ? [t(organisationErrors?.['sworn'])] : null} />
            </>
        </Card.FormStep>
    );
}
SwornStatement.propTypes = {
    formOrganisation: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired
};
